module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25d1e4a6a9db8d03fa8f5878e45d26c7.png";